import Construction from './Construction.svg';
import Electronics from './Electronics.svg';
import FashinBeatuy from './Fashin & beatuy.svg';
import Food from './Food.svg';
import HomeGarden from './Home & Garden.svg';
import Kids from './Kids.svg';
import Service from './Service.svg';
import Vehicle from './Vehicle.svg';

const icons = {
  Construction,
  Electronics,
  FashinBeatuy,
  Food,
  HomeGarden,
  Kids,
  Service,
  Vehicle,
};

export default icons;